import * as React from "react";

const SvgIcnError = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 48 48" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M24.45 8.202a1 1 0 01.444.445L39.92 38.551A1 1 0 0139.026 40H9a1 1 0 01-.894-1.448l15-29.904a1 1 0 011.342-.446zM24 31a2 2 0 100 4 2 2 0 000-4zm0-13a2 2 0 00-2 2v7a2 2 0 104 0v-7a2 2 0 00-2-2z"
        />
    </svg>
);

export default SvgIcnError;
